import styled from "@emotion/styled";

export const Wrapper = styled.div`
  max-width: 1048px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 0 20px;
`;
